// Layout.js
import React from 'react';
import Header from './Header';
import Footer from './Footer';
import { Analytics } from "@vercel/analytics/react"

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow bg-gray-50 p-4 md:p-8">
        {children}
        <Analytics />
        
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
